export default [
    {
        path: 'smsLogs',
        meta: {
            title: '短信记录'
        },
        component: () => import('../pages/sms/SmsLogs.vue'),
    },



]
